export function getdata() {
	var obj = {
		
			headData: [{
					title: "行次",
					prop:'groud',
					width: "100px",
					custom: true,
					fixed:'left'
				},
				{
					title: "项目",
					prop:'title',
					width: "350px",
					custom: true,
					fixed:'left'

				},
				{
					title: "本年累计折旧\摊销（扣除）金额",
					children:[{
					
					title: "本年享受优惠的资产原值",
						children:[{
							title: "1",
							prop: "sdsA_2_x_1",
							custom: true,
							width: "200px"
						}]
					},
					{
					
					title: "账载折旧\摊销金额",
						children:[{
							
							title: "2",
							prop: "sdsA_2_x_2",
							custom: true,
							width: "200px"
						}]
					},
					{
					
					title: "按照税收一般规定计算的折旧\摊销金额",
						children:[{
							title: "3",
							prop: "sdsA_2_x_3",
							custom: true,
							width: "250px"
						}]
					},
					{
					
					title: "享受加速政策计算的折旧\摊销金额",
						children:[{
							
							title: "4",
							prop: "sdsA_2_x_4",
							custom: true,
							width: "250px"
						}]
					},
					{
					
					title: "纳税调减金额",
						children:[{
							
							title: "5",
							prop: "sdsA_2_x_5",
							custom: true,
							width: "200px"
						}]
					},
					{
					
					title: "享受加速政策优惠金额",
						children:[{
							
							title: "6",
							prop: "sdsA_2_x_6",
							custom: true,
							width: "200px"
						}]
					}
					]
					
				},
				
			],
			tableData: [
				{
					title:'一、加速折旧、摊销（不含一次性扣除，1.1+1.2+...）',
					groud:'1',
					disabledsdsA_2_x_1:true,
					disabledsdsA_2_x_2:true,
					disabledsdsA_2_x_3:true,
					disabledsdsA_2_x_4:true,
					disabledsdsA_2_x_5:true,
					disabledsdsA_2_x_6:true,
				},
				{
					groud:'1.1',
					title:'（一）重要行业固定资产加速折旧',
					disabledsdsA_2_x_1:false,
					disabledsdsA_2_x_2:false,
					disabledsdsA_2_x_3:false,
					disabledsdsA_2_x_4:false,
					disabledsdsA_2_x_5:false,
					disabledsdsA_2_x_6:true,
				},{
					groud:'1.2',
					title:'（二）其他行业研发设备加速折旧',
					disabledsdsA_2_x_1:false,
					disabledsdsA_2_x_2:false,
					disabledsdsA_2_x_3:false,
					disabledsdsA_2_x_4:false,
					disabledsdsA_2_x_5:false,
					disabledsdsA_2_x_6:true,
				},{
					groud:'1.3',
					title:'（三）海南自由贸易港企业固定资产加速折旧',
					disabledsdsA_2_x_1:false,
					disabledsdsA_2_x_2:false,
					disabledsdsA_2_x_3:false,
					disabledsdsA_2_x_4:false,
					disabledsdsA_2_x_5:false,
					disabledsdsA_2_x_6:true,
				},{
					groud:'1.4',
					title:'（四）海南自由贸易港企业无形资产加速摊销',
					disabledsdsA_2_x_1:false,
					disabledsdsA_2_x_2:false,
					disabledsdsA_2_x_3:false,
					disabledsdsA_2_x_4:false,
					disabledsdsA_2_x_5:false,
					disabledsdsA_2_x_6:true,
				},{
					groud:'2',
					title:'二、固定资产、无形资产一次性扣除（2.1+2.2+...）',
					disabledsdsA_2_x_1:true,
					disabledsdsA_2_x_2:true,
					disabledsdsA_2_x_3:true,
					disabledsdsA_2_x_4:true,
					disabledsdsA_2_x_5:true,
					disabledsdsA_2_x_6:true,
				},{
					groud:'2.1',
					title:'（一）500万元以下设备器具一次性扣除',
					disabledsdsA_2_x_1:false,
					disabledsdsA_2_x_2:false,
					disabledsdsA_2_x_3:false,
					disabledsdsA_2_x_4:false,
					disabledsdsA_2_x_5:false,
					disabledsdsA_2_x_6:true,
				},{
					groud:'2.2',
					title:'（二）海南自由贸易港企业固定资产一次性扣除',
					disabledsdsA_2_x_1:false,
					disabledsdsA_2_x_2:false,
					disabledsdsA_2_x_3:false,
					disabledsdsA_2_x_4:false,
					disabledsdsA_2_x_5:false,
					disabledsdsA_2_x_6:true,
				},{
					groud:'2.3',
					title:'（三）海南自由贸易港企业无形资产一次性扣除',
					disabledsdsA_2_x_1:false,
					disabledsdsA_2_x_2:false,
					disabledsdsA_2_x_3:false,
					disabledsdsA_2_x_4:false,
					disabledsdsA_2_x_5:false,
					disabledsdsA_2_x_6:true,
				},{
					groud:'2.4',
					title:'（四）中小微企业单价500万元以上设备器具一次性扣除（折旧年限为三年）',
					disabledsdsA_2_x_1:false,
					disabledsdsA_2_x_2:false,
					disabledsdsA_2_x_3:false,
					disabledsdsA_2_x_4:false,
					disabledsdsA_2_x_5:false,
					disabledsdsA_2_x_6:true,
				},{
					groud:'2.5',
					title:'（五）中小微企业单价500万元以上设备器具50%部分一次性扣除（折旧年限为4、5年）',
					disabledsdsA_2_x_1:false,
					disabledsdsA_2_x_2:false,
					disabledsdsA_2_x_3:false,
					disabledsdsA_2_x_4:false,
					disabledsdsA_2_x_5:false,
					disabledsdsA_2_x_6:true,
				},{
					groud:'2.6',
					title:'（六）中小微企业单价500万元以上设备器具50%部分一次性扣除（折旧年限为10年）',
					disabledsdsA_2_x_1:false,
					disabledsdsA_2_x_2:false,
					disabledsdsA_2_x_3:false,
					disabledsdsA_2_x_4:false,
					disabledsdsA_2_x_5:false,
					disabledsdsA_2_x_6:true,
				},{
					groud:'3',
					title:'合计（1+2）',
					disabledsdsA_2_x_1:true,
					disabledsdsA_2_x_2:true,
					disabledsdsA_2_x_3:true,
					disabledsdsA_2_x_4:true,
					disabledsdsA_2_x_5:true,
					disabledsdsA_2_x_6:true,
				},
			]
		
	}
	return obj
}
